import React from "react";
import { Modal, Row, Col, Form, Container, InputGroup } from "react-bootstrap";
import parse from 'html-react-parser';

import CancelButton from "presentation/components/buttons/cancel";
import AddButton from "presentation/components/buttons/add";

import { handleChange } from "presentation/utils/functions/generic";

import EvaluationFormula from "presentation/pages/evaluation-schemes/elements/evaluation-formula/evaluation-formula";

import { generateStatusIndicationVirtualId } from "presentation/pages/evaluation-schemes/functions/status-indications";
import { TERM_INFO_ITEM_TYPE_EVALUATION_PERIOD } from "presentation/model/constants";

class ManageStatusIndicationModal extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            loading: false,
            form: {
                formula: []
            }
        };
    }

    componentDidMount() {
        let { statusIndication = {} } = this.props;
        this.setState({ form: statusIndication });
        this.loadTerms();
    }

    componentDidUpdate(prevProps, prevState) {
        const { periods, statusIndication } = this.props;
        const { periods: previousPeriodParam, statusIndication: previousStatusIndicationParam } = prevProps;

        if (statusIndication != previousStatusIndicationParam) {
            this.setState({ form: statusIndication });
        }

        if (periods != previousPeriodParam) {
            this.loadTerms();
        }
    }

    loadTerms = () => {
        let { periods } = this.props;
        let terms = periods.map((p, pi) => {
            return { stageId: p.stageId, id: p.id, displayName: p.name, machineName: `period:${p.id}`, isUnique: true, termInfoItemType: TERM_INFO_ITEM_TYPE_EVALUATION_PERIOD };
        });
        this.setState({ terms: terms });
    }

    updateExpression = (entityKey, elements) => {
        const { form } = this.state;
        this.setState({ form: { ...form, formula: elements } });
    }

    onSubmit = () => {

        let { onClose, afterSubmit, component, statusIndicationKey } = this.props;
        let { form } = this.state;
        let { statusIndications: existingStatusIndications } = component.state;
        let hasError = !form.periodId;

        if (hasError) {
            this.setState({ loading: false, error: true, message: "Campos obrigatórios não foram preenchidos. Por favor, verifique  o período. " });
        } else {

            let statusIndication = form;
            let existing = existingStatusIndications.filter(x => x.key == statusIndicationKey)[0];

            if (!existing) {
                let tempId = generateStatusIndicationVirtualId();
                statusIndication.id = tempId;
                statusIndication.tempId = tempId;
                statusIndication.isVirtualId = true;
                statusIndication.key = statusIndicationKey;
            }

            let finalStatusIndications = [...existingStatusIndications.filter(x => x.key !== statusIndicationKey), statusIndication];

            component.setState({
                statusIndications: finalStatusIndications,
                totalStatusIndicationItems: finalStatusIndications.length
            }, () => {
                this.setState({
                    form: {}
                }, () => {
                    afterSubmit();
                    onClose();
                });
            });


        }
    };


    render() {
        let { show, onClose, periods, statusIndicationKey, mode = "add" } = this.props;
        let { loading, form, terms } = this.state;
        let { periodId } = form || {};

        const { onSubmit, updateExpression } = this;

        let component = this;
        let entityKey = statusIndicationKey;

        let periodIdValue = periodId ? ("" + periodId) : "";
        let existingElements = form.formula || [];

        return (
            <Modal size="fullscreen" backdrop="static" show={show || false} onHide={onClose}>
                <Modal.Header closeButton>
                    <Modal.Title>{mode == "add" ? "Adicionar" : "Editar"} indicação de situação</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <Container>
                        <Row>
                            <Col lg={6}>
                                <Form.Label htmlFor="periodId">Indicar o período</Form.Label>
                                <Form.Select
                                    aria-label="Periodo"
                                    value={periodIdValue}
                                    id={`periodId`}
                                    name={`periodId`}
                                    data-field-name="periodId"
                                    onChange={(e) => handleChange(e, component)}
                                    required
                                >
                                    <option key="-1" value="-1">Selecione</option>
                                    {periods.map((e, i) => { return <option key={e.id} value={e.id}>{e.name}</option> })}
                                </Form.Select>
                            </Col>
                            <Col>
                                <div className="form">
                                    <Form.Label htmlFor="neededScore">{"Se o resultado da fórmula abaixo for < que"}</Form.Label>
                                    <Form.Control
                                        type="text"
                                        id="neededScore"
                                        name="neededScore"
                                        defaultValue={form.neededScore}
                                        onChange={(e) => handleChange(e, component)}
                                    />
                                </div>
                            </Col>
                        </Row>

                        {/* Verificar porque está acontecendo bug no carregamento dos elementos por esse component e remover o código "duplicado" abaixo */}
                        {!form.formula &&
                            <div className="mt-2">
                                <strong>Fórmula customizada:</strong>
                                <EvaluationFormula component={component} entityKey={entityKey} sortableKey={`ev-status-situation-${entityKey}`} updateExpression={updateExpression} terms={terms} />
                            </div>
                        }
                        {form.formula &&
                            <div className="mt-2">
                                <strong>Fórmula customizada:</strong>
                                <EvaluationFormula component={component} entityKey={entityKey} sortableKey={`ev-status-situation-${entityKey}`} updateExpression={updateExpression} terms={terms} existingElements={existingElements} />
                            </div>
                        }

                    </Container>
                </Modal.Body>
                <Modal.Footer>
                    <CancelButton
                        containerProps={{
                            disabled: loading,
                            onClick: onClose
                        }}
                    />
                    <AddButton
                        title={"Salvar"}
                        containerProps={{
                            onClick: () => onSubmit(),
                            variant: 'success',
                            disabled: loading
                        }}
                    />
                </Modal.Footer>
            </Modal >
        );
    };
}

export default ManageStatusIndicationModal;